const AUTH_API_URL =
  "https://auth-coaching-dashboard-386051205660.us-central1.run.app";

export const authService = {
  async verifyInstitution(institutionId, password) {
    try {
      const response = await fetch(`${AUTH_API_URL}/auth/${institutionId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      });

      if (!response.ok) {
        throw new Error("Institution authentication failed");
      }

      const data = await response.json();

      if (data.auth) {
        localStorage.setItem(`auth_${institutionId}`, "true");
        return data;
      } else {
        throw new Error(data.message || "Authentication failed");
      }
    } catch (error) {
      console.error("Institution auth verification error:", error);
      throw error;
    }
  },

  isInstitutionAuthenticated(institutionId) {
    return localStorage.getItem(`auth_${institutionId}`) === "true";
  },

  logoutInstitution(institutionId) {
    localStorage.removeItem(`auth_${institutionId}`);
  },

  async fetchInstitutionData(institutionId) {
    try {
      const response = await fetch(
        `${AUTH_API_URL}/snippets/data/${institutionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch institution data");
      }

      return await response.json();
    } catch (error) {
      console.error("Data fetch error:", error);
      throw error;
    }
  },
};
